import {useCallback, useState} from 'react';
import {
    DEFAULT_TABLE_PAGE_SIZE,
    TABLE_PAGE_SIZE_LABEL,
    TABLE_PAGE_SIZE_OPTIONS,
} from './tablePageSize';

export function useDataTablePagination() {
    const [page, setPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(DEFAULT_TABLE_PAGE_SIZE);

    const onRecordsPerPageChange = useCallback((value: number) => {
        setRecordsPerPage(value);
        setPage(1);
    }, []);

    const paginate = useCallback(<T,>(items: readonly T[]): T[] => {
        const from = (page - 1) * recordsPerPage;
        return items.slice(from, from + recordsPerPage);
    }, [page, recordsPerPage]);

    const getPaginationProps = useCallback((totalRecords: number) => ({
        page,
        onPageChange: setPage,
        recordsPerPage,
        onRecordsPerPageChange,
        recordsPerPageOptions: [...TABLE_PAGE_SIZE_OPTIONS],
        recordsPerPageLabel: TABLE_PAGE_SIZE_LABEL,
        totalRecords,
    }), [page, recordsPerPage, onRecordsPerPageChange]);

    return {
        page,
        setPage,
        recordsPerPage,
        paginate,
        getPaginationProps,
    };
}
